package com.eladfinish.bible.contest.platform

import kotlinx.browser.window

class WebAppInfoProvider : AppInfoProvider {
    override fun appId(): String = window.location.hostname
    override fun appVersionName(): String = WebBuildInfo.VERSION_NAME
    override fun deviceModel(): String = userAgentLabel(window.navigator.userAgent)
}
